import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Grid,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add"; // Add this import
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import axios from "axios"; // Add this import if not present
import imageCompression from "browser-image-compression";

const menuItems = [
  "Home",
  "Users",
  "Album",
  "Frame",
  "Price",
  "Contact",
  "About",
  "Feedback" // <-- Add this line
];

// Custom hook for scroll direction
function useScrollDirection() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const onScroll = () => {
      if (window.scrollY < lastScrollY || window.scrollY < 10) {
        setShow(true); // Scrolling up or near top
      } else {
        setShow(false); // Scrolling down
      }
      lastScrollY = window.scrollY;
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return show;
}

const studioImages = [
  "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
  "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
  "https://images.unsplash.com/photo-1517841905240-472988babdf9", // <-- replaced with a valid Unsplash image
  "https://images.unsplash.com/photo-1465101178521-c1a4c8a0a8b7",
  "https://images.unsplash.com/photo-1519985176271-adb1088fa94c"
];


// Dummy images for services (replace with your own URLs if needed)
const serviceImages = [
  "https://images.unsplash.com/photo-1519125323398-675f0ddb6308", // Portrait
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb", // Wedding
  "https://images.unsplash.com/photo-1465101046530-73398c7f28ca", // Puberty
  "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429", // Birthday
  "https://images.unsplash.com/photo-1517841905240-472988babdf9", // Pre Wedding
  "https://images.unsplash.com/photo-1519985176271-adb1088fa94c", // Post Wedding
"https://images.unsplash.com/photo-1517841905240-472988babdf9",  // Outdoor
   "https://images.unsplash.com/photo-1506744038136-46273834b3fb",  // Meeting (changed)
];




const AdminHome = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const showAppBar = useScrollDirection();
  const studioName = localStorage.getItem("studioName") || "LC Studio";
  const clientMongoId = localStorage.getItem("clientMongoId") || "";
  // console.log("AdminHome - clientMongoId:", clientMongoId); // <-- Print home id
  const navigate = useNavigate();
  const location = useLocation();
  const isIndex = location.pathname === "/admin-home";

  // Image slider state
  const [currentImg, setCurrentImg] = useState(0);
  const [serviceData, setServiceData] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImg((prev) => (prev + 1) % studioImages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const [flipped, setFlipped] = useState(Array(serviceData.length).fill(false));

  const handleFlip = (idx) => {
    setFlipped((prev) => prev.map((f, i) => (i === idx ? !f : f)));
  };

  const [editIdx, setEditIdx] = useState(null); // index of card being edited
  const [editTitle, setEditTitle] = useState("");
  const [editDesc, setEditDesc] = useState("");
  const [editImg, setEditImg] = useState("");
  const [showDeleteIdx, setShowDeleteIdx] = useState(null); // index for delete confirmation
  const [descEditMode, setDescEditMode] = useState(false);
  const [descText, setDescText] = useState("");  
  const [footerEditMode, setFooterEditMode] = useState(false);
  
  // const [footerStudioEditMode, setFooterStudioEditMode] = useState(false);
  // const [footerStudioText, setFooterStudioText] = useState("");
  // const [footerText, setFooterText] = useState("");
  // const [footerTagEditMode, setFooterTagEditMode] = useState(false);
  // const [footerTagText, setFooterTagText] = useState("");

  // const [footerHandleEditMode, setFooterHandleEditMode] = useState(false);
  // const [footerHandleText, setFooterHandleText] = useState("");

  // const [footerCopyrightEditMode, setFooterCopyrightEditMode] = useState(false);
  // const [footerCopyrightText, setFooterCopyrightText] = useState("");

  // const [footerMadeEditMode, setFooterMadeEditMode] = useState(false);
  // const [footerMadeText, setFooterMadeText] = useState("");

  const [footers, setFooters] = useState({
  studio: "",
  tag: "",
  handle: "",
  copyright: "",
  made: "",
  text: ""
});
  
  const [editDetailsIdx, setEditDetailsIdx] = useState(null); // index of card being edited for details
  const [editDetailsText, setEditDetailsText] = useState("");

  // Add state for add card dialog and fields
  const [addCardIdx, setAddCardIdx] = useState(null);
  const [newCardImg, setNewCardImg] = useState("");
  const [newCardTitle, setNewCardTitle] = useState("");
  const [newCardDesc, setNewCardDesc] = useState("");
  const [newCardDetails, setNewCardDetails] = useState("");

  // Add these states at the top of your AdminHome component:
  const [editStudioImagesOpen, setEditStudioImagesOpen] = useState(false);
  const [selectedStudioImages, setSelectedStudioImages] = useState(studioImages.slice(0, 5));
  const [editImgIdx, setEditImgIdx] = useState(null);
  
useEffect(() => {
  async function fetchImages() {
    if (!clientMongoId) return;
    try {
      const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/studio-images`);
      // If no images in DB, use default 5 images
      setSelectedStudioImages(
        res.data.studioImages && res.data.studioImages.length === 5
          ? res.data.studioImages
          : studioImages.slice(0, 5)
      );
    } catch (err) {
      setSelectedStudioImages(studioImages.slice(0, 5));
    }
  }
  fetchImages();
}, [clientMongoId]);
  // Handler for file input change (single image for replacement)
const handleSingleStudioImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (ev) => {
    setSelectedStudioImages((prev) =>
      prev.map((img, idx) => (idx === editImgIdx ? ev.target.result : img))
    );
    setEditImgIdx(null);
  };
  reader.readAsDataURL(file);
};

const handleSaveStudioImages = async () => {
  if (!clientMongoId) return;
  try {
    await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/studio-images`, {
      studioImages: selectedStudioImages,
    });
    setEditStudioImagesOpen(false);
    setCurrentImg(0);
    // Show success message
    alert("Studio images stored successfully!");
  } catch (err) {
    // Show error message
    alert("Studio images not stored. Please try again.");
  }
};

  

 useEffect(() => {
  async function fetchDescription() {
    if (!clientMongoId) return;
    try {
      const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/studio-description`);
      setDescText(res.data.studioDescription || "");
    } catch (err) {
      console.error("Fetch error:", err);
    }
  }
  fetchDescription();
}, [clientMongoId]);

const handleSaveDescription = async () => {
  if (!clientMongoId) return;
  try {
    await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/studio-description`, {
      studioDescription: descText,
    });
    setDescEditMode(false);
    // Optionally refetch to confirm update
    const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/studio-description`);
    setDescText(res.data.studioDescription || "");
    alert("Changes stored successfully!");
  } catch (err) {
    console.error("Save error:", err);
    alert("Changes not stored. Please try again.");
  }
};

useEffect(() => {
  setFlipped(Array(serviceData.length).fill(false));
}, [serviceData]);

useEffect(() => {
  async function fetchServices() {
    if (!clientMongoId) return;
    try {
      const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/services`);
      // If no cards in DB, use default 5 cards
      setServiceData(
        res.data.services && res.data.services.length >= 5
          ? res.data.services
          : serviceImages.slice(0, 5).map((img, idx) => ({
              img,
              title: `Service ${idx + 1}`,
              desc: "",
              details: ""
            }))
      );
    } catch (err) {
      setServiceData(
        serviceImages.slice(0, 5).map((img, idx) => ({
          img,
          title: `Service ${idx + 1}`,
          desc: "",
          details: ""
        }))
      );
    }
  }
  fetchServices();
}, [clientMongoId]);


// Save services to database
const saveServicesToDB = async (services) => {
  if (!clientMongoId) return;
  try {
    await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/services`, {
      services
    });
    alert("Services updated successfully!");
  } catch (err) {
    alert("Failed to update services.");
  }
};

const handleSaveEditService = () => {
  if (editIdx === null) return;
  const updated = [...serviceData];
  updated[editIdx] = {
    ...updated[editIdx],
    img: editImg,
    title: editTitle,
    desc: editDesc
  };
  setServiceData(updated);
  setEditIdx(null);
  saveServicesToDB(updated);
};

// Delete Service
const handleDeleteService = () => {
  const updated = serviceData.filter((_, i) => i !== showDeleteIdx);
  setServiceData(updated);
  setShowDeleteIdx(null);
  saveServicesToDB(updated);
};

// Edit Details
const handleSaveEditDetails = () => {
  const updated = [...serviceData];
  updated[editDetailsIdx] = {
    ...updated[editDetailsIdx],
    details: editDetailsText
  };
  setServiceData(updated);
  setEditDetailsIdx(null);
  saveServicesToDB(updated);
};

// Add Service
const handleSaveNewCard = () => {
  const updated = [...serviceData];
  updated.splice(addCardIdx + 1, 0, {
    title: newCardTitle || "New Service",
    img: newCardImg,
    desc: newCardDesc,
    details: newCardDetails
  });
  setServiceData(updated);
  setAddCardIdx(null);
  setNewCardImg("");
  setNewCardTitle("");
  setNewCardDesc("");
  setNewCardDetails("");
  saveServicesToDB(updated);
};
const handleAddCard = (idx) => {
  setAddCardIdx(idx);
  setNewCardImg("");
  setNewCardTitle("");
  setNewCardDesc("");
  setNewCardDetails("");
};

useEffect(() => {
  async function fetchFooters() {
    if (!clientMongoId) return;
    try {
      const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`);
      setFooters(res.data.footers || {});
    } catch (err) {
      setFooters({
        studio: "",
        tag: "",
        handle: "",
        copyright: "",
        made: "",
        text: ""
      });
    }
  }
  fetchFooters();
}, [clientMongoId]);

const handleSaveFooters = async () => {
  if (!clientMongoId) return;
  try {
    await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`, {
      footers
    });
    setFooterEditMode({
      studio: false,
      tag: false,
      handle: false,
      copyright: false,
      made: false,
      text: false
    });
    alert("Footer updated!");
  } catch (err) {
    alert("Failed to update footer.");
  }
};


  return (
    <>
      <Slide appear={false} direction="down" in={showAppBar}>
        <AppBar position="fixed" sx={{ bgcolor: "#fff", boxShadow: isMobile ?1.2:3,height: isMobile ? 56 : 80 }}>
          <Toolbar sx={{ minHeight: isMobile ? 56 : 80, px: isMobile ? 1 : 3 }}>
            {/* Desktop: Studio name left, menu center */}
            {!isMobile ? (
              <>
                <Typography
                  variant="h4"
                  sx={{
                    fontFamily: "Josefin Sans",
                    fontWeight: 700,
                    color: "#1976d2",
                    letterSpacing: 2,
                    mr: 2 // reduced margin
                  }}
                >
                  {studioName}
                </Typography>
                <Box sx={{ flex: 1 }}>
                  <Grid container spacing={1} justifyContent="center">
                    {/* First row: Home, Users, Album, Frame */}
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                        {menuItems.slice(0, 4).map((item) => (
                          <Typography
                            key={item}
                            variant="subtitle1"
                            sx={{
                              color: "black",
                              fontWeight: 600,
                              fontFamily: "Josefin Sans",
                              fontSize: 25,
                              cursor: "pointer",
                              px: 1,
                              py: 0.5,
                              borderRadius: 2,
                              "&:hover": { bgcolor: "rgba(0,0,0,0.08)" }
                            }}
                            onClick={() => {
                             if (item === "Users") navigate("/admin-home/users");
                             else if (item === "Home") navigate("/admin-home");
                             else if (item === "Album") navigate("/admin-home/albums");
                             else if (item === "Frame") navigate("/admin-home/frame");
                              
                              // Add more navigation if needed
                            }}
                          >
                            {item}
                          </Typography>
                        ))}
                      </Box>
                    </Grid>
                    {/* Second row: Price, Contact, About */}
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                        {menuItems.slice(4).map((item) => (
                          <Typography
                            key={item}
                            variant="subtitle1"
                            sx={{
                              color: "black",
                              fontWeight: 600,
                              fontFamily: "Josefin Sans",
                              fontSize: 25,
                              cursor: "pointer",
                              px: 1,
                              py: 0.5,
                              borderRadius: 2,
                              "&:hover": { bgcolor: "rgba(0,0,0,0.08)" }
                            }}
                            onClick={() => {
                              if (item === "Price") navigate("/admin-home/price");
                              else if (item === "Contact") navigate("/admin-home/contact");
                              else if (item === "About") navigate("/admin-home/about");
                              else if (item === "Feedback") navigate("/admin-home/feedback"); // <-- Add this line
                            }}
                          >
                            {item}
                          </Typography>
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </>
            ) : (
              // Mobile: Studio name center, menu icon right
              <>
                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    sx={{
                      fontFamily: "Josefin Sans",
                      fontWeight: 700,
                      color: "#1976d2",
                      letterSpacing: 2,
                      mr: !isMobile ? 2 : 0 // reduced margin
                    }}
                  >
                    {studioName}
                  </Typography>
                </Box>
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={() => setDrawerOpen(true)}
                  sx={{ ml: "auto" }}
                >
                  <MenuIcon sx={{ color: "black" }} />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={drawerOpen}
                  onClose={() => setDrawerOpen(false)}
                >
                  <Box sx={{ width: 220, pt: 2 }}>
                    <List>
                      {menuItems.map((item) => (
                        <ListItem
                          button
                          key={item}
                          onClick={() => {
                            setDrawerOpen(false);
                            if (item === "Users") navigate("/admin-home/users");
                            else if (item === "Home") navigate("/admin-home");
                            else if (item === "Album") navigate("/admin-home/albums");
                            else if (item === "Frame") navigate("/admin-home/frame");
                            else if (item === "Price") navigate("/admin-home/price");
                            else if (item === "Contact") navigate("/admin-home/contact");
                            else if (item === "About") navigate("/admin-home/about");
                            else if (item === "Feedback") navigate("/admin-home/feedback"); // <-- Add this line
                            // Add more navigation if needed
                          }}
                        >
                          <ListItemText
                            primary={item}
                            primaryTypographyProps={{
                              fontWeight: 600,
                              fontSize: 20,
                              color: "black"
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Drawer>
              </>
            )}
          </Toolbar>
        </AppBar>
      </Slide>
      {/* Page content */}
      {isIndex ? (
  <Box sx={{ p: 2, pt: isMobile ? 10 : 15 }}>
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
      {/* Only one studio image visible at a time with fade effect */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 1800,
          height: { xs: 220, sm: 320, md: 540 },
          overflow: "hidden",
          borderRadius: 5,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          mb: 2,
          position: "relative",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img
          src={selectedStudioImages[currentImg]}
          alt={`studio-${currentImg}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 12,
            transition: "opacity 0.5s"
          }}
        />
        <IconButton
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            bgcolor: "#fff",
            boxShadow: 1,
            "&:hover": { bgcolor: "#e3f2fd" }
          }}
          size="large"
          onClick={() => setEditStudioImagesOpen(true)}
        >
          <EditIcon fontSize="large" />
        </IconButton>
      </Box>
     <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
  {descEditMode ? (
    <>
      <TextField
        multiline
        minRows={2}
        value={descText}
        onChange={e => setDescText(e.target.value)}
        sx={{ width: isMobile ? 320 : 800, mr: 2 }}
      />
      <Button
  variant="contained"
  onClick={handleSaveDescription} // <-- Call the save function!
  sx={{ height: 40 }}
>
  Save
</Button>
    </>
  ) : (
    <>
      <Typography
        variant="h6"
        sx={{
          maxWidth: 1500,
          textAlign: "center",
          color: "black",
          fontWeight: 500,
          fontFamily: "Jost",
          fontSize: isMobile ? 18 : 24,
          lineHeight: 1.6,
          mr: 2
        }}
      >
        {descText}
      </Typography>
      <IconButton
        size="small"
        onClick={() => setDescEditMode(true)}
        sx={{ bgcolor: "#fff", boxShadow: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </>
  )}
</Box>
    </Box>
    {/* Services section */}
    <Box sx={{ mt: 6, mb: 2 }}>
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontFamily: "Josefin Sans",
          mb: 4,
          color: "black",
          letterSpacing: 2
        }}
      >
        Services
      </Typography>
      <Grid container spacing={{ xs: 2, sm: 4, md: 10 }} columns={12} justifyContent="center">
        {serviceData.map((service, idx) => (
          <Grid
            item
            xs={12}    // 1 per row on mobile
  sm={6}     // 2 per row on tablet
  md={3}     // 4 per row on desktop (12/3 = 4)
            key={service.title}
            sx={{
              display: "flex",
              justifyContent: "center",
              
            }}
          >
            <Box
              sx={{
                perspective: "1200px",
                width: { xs: 180, sm: 260, md: 340 },
                height: { xs: 260, sm: 340, md: 400 },
                bgcolor: "transparent",
                mb: isMobile ? 4 : 0,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  transition: "transform 0.6s",
                  transformStyle: "preserve-3d",
                  transform: flipped[idx] ? "rotateY(180deg)" : "none"
                }}
              >
                {/* Front Side */}
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    bgcolor: "#fff",
                    borderRadius: 4,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <img
                      src={service.img}
                      alt={service.title}
                      style={{
                        width: isMobile ? 280 : 300,
                        height: isMobile ? 180 : 200,
                        objectFit: "cover",
                        borderRadius: 8,
                        marginBottom: 16
                      }}
                    />
                    <IconButton
                      sx={{
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                        bgcolor: "#fff",
                        boxShadow: 1,
                        "&:hover": { bgcolor: "#e3f2fd" }
                      }}
                      size="small"
                      onClick={() => {
                        setEditIdx(idx);
                        setEditImg(service.img);
                        setEditTitle(service.title);
                        setEditDesc(service.desc);
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#1976d2",
                      mb: 1,
                      textAlign: "center",
                      fontFamily: "Jost"
                    }}
                  >
                    {service.title}
                  </Typography>
                 <Typography
  variant="body2"
  sx={{
    color: "black",
    textAlign: "center",
    mb: 2,
    fontFamily: "Josefin Sans",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    width: "100%",
    maxHeight: 80, // adjust as needed
    overflowY: "auto"
  }}
>
  {service.desc}
</Typography>
                  <Box sx={{ textAlign: "center", position: "relative" }}>
                    <button
                      style={{
                        background: "#1976d2",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        padding: "8px 20px",
                        fontWeight: 600,
                        cursor: "pointer",
                        fontSize: 16,
                        fontFamily: "Jost",
                        boxShadow: "0 2px 8px rgba(25,118,210,0.08)"
                      }}
                      onClick={() => handleFlip(idx)}
                    >
                      More Info
                    </button>
                    {/* Delete icon at bottom right */}
                    <IconButton
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: -80,
                        bgcolor: "#fff",
                        boxShadow: 1,
                        "&:hover": { bgcolor: "#fdecea" }
                      }}
                      size="small"
                      onClick={() => setShowDeleteIdx(idx)}
                    >
                      <DeleteIcon fontSize="small" sx={{ color: "#d32f2f" }} />
                    </IconButton>
                    {/* Add icon at bottom right, above the Delete icon */}
                    <IconButton
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: -40,
                        bgcolor: "#fff",
                        boxShadow: 1,
                        "&:hover": { bgcolor: "#e3f2fd" }
                      }}
                      size="small"
                      onClick={() => handleAddCard(idx)}
                    >
                      <AddIcon fontSize="small" sx={{ color: "#1976d2" }} />
                    </IconButton>
                  </Box>
                </Box>
                {/* Back Side */}
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    bgcolor: "#fff",
                    borderRadius: 4,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    transform: "rotateY(180deg)"
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#1976d2",
                      mb: 2,
                      textAlign: "center",
                      fontFamily: "Josefin Sans"
                    }}
                  >
                    {service.title}
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
  <Typography
    variant="body2"
    sx={{
      color: "black",
      textAlign: "center",
      whiteSpace: "pre-line",
      mr: 2,
      fontFamily: "Jost",
    }}
  >
    {service.details}
  </Typography>
  <IconButton
    size="small"
    onClick={() => {
      setEditDetailsIdx(idx);
      setEditDetailsText(service.details);
    }}
    sx={{ bgcolor: "#fff", boxShadow: 1,marginTop:-25,marginLeft:-0, "&:hover": { bgcolor: "#e3f2fd" } }}
  >
    <EditIcon  fontSize="small" />
  </IconButton>
</Box>
                  <Box sx={{ textAlign: "center" }}>
                    <button
                      style={{
                        background: "#1976d2",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        padding: "8px 20px",
                        fontWeight: 600,
                        cursor: "pointer",
                        fontSize: 16,
                        boxShadow: "0 2px 8px rgba(25,118,210,0.08)"
                      }}
                      onClick={() => handleFlip(idx)}
                    >
                      Back
                    </button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
) : (
  <Box sx={{ pt: isMobile ? 8 : 10 }}>
    <Outlet />
  </Box>
)}
      {/* Footer Section */}
      <Box
        sx={{
          bgcolor: "#a67c52", // mild brown
          color: "#fff",
         
          mt: 7,
          pt: 5,
          pb: 2
        }}
      >
        <Grid container spacing={2} sx={{ maxWidth: 1200, mx: "auto" }}>
          {/* Left Column */}
          <Grid item xs={12} md={3} sx={{ml: isMobile ? 2 : 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1, }}>
              {footerEditMode.studio ? (
                <>
                  <TextField
                    value={footers.studio}
                    onChange={e => setFooters({ ...footers, studio: e.target.value })}
                    sx={{ width: 140, mr: 1 }}
                  />
                  <Button variant="contained" onClick={handleSaveFooters} sx={{ height: 40,fontFamily:"Josefin Sans" }}>Save</Button>
                </>
              ) : (
                <>
                  <Typography variant="h5" sx={{ fontWeight: 700,fontFamily:"Josefin Sans" }}>
                    {footers.studio}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFooterEditMode({ ...footerEditMode, studio: true })}
                    sx={{ bgcolor: "#fff", boxShadow: 1, ml: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              {footerEditMode.tag ? (
                <>
                  <TextField
                    value={footers.tag}
                    onChange={e => setFooters({ ...footers, tag: e.target.value })}
                    sx={{ width: 140, mr: 1 }}
                  />
                  <Button variant="contained" onClick={handleSaveFooters} sx={{ height: 40,fontFamily:"Josefin Sans" }}>Save</Button>
                </>
              ) : (
                <>
                  <Typography variant="body1" sx={{fontFamily:"Jost"}}>{footers.tag}</Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFooterEditMode({ ...footerEditMode, tag: true })}
                    sx={{ bgcolor: "#fff", boxShadow: 1, ml: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              {footerEditMode.handle ? (
                <>
                  <TextField
                    value={footers.handle}
                    onChange={e => setFooters({ ...footers, handle: e.target.value })}
                    sx={{ width: 140, mr: 1 }}
                  />
                  <Button variant="contained" onClick={handleSaveFooters} sx={{ height: 40,fontFamily:"Josefin Sans" }}>Save</Button>
                </>
              ) : (
                <>
                  <Typography variant="body2" sx={{fontFamily:"Jost"}}>{footers.handle}</Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFooterEditMode({ ...footerEditMode, handle: true })}
                    sx={{ bgcolor: "#fff", boxShadow: 1, ml: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
          </Grid>
          {/* Center Column */}
          <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", ml: isMobile ? 2 : 0, ml: isMobile ? 2 : 8,mt: isMobile ? 2 : 8 }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
      {footerEditMode.text ? (
        <>
          <TextField
            multiline
            minRows={2}
            value={footers.text}
            onChange={e => setFooters({ ...footers, text: e.target.value })}
            sx={{ width: isMobile ? 320 : 800, mr: 2 }}
          />
          <Button variant="contained" onClick={handleSaveFooters} sx={{ height: 40,fontFamily:"Josefin Sans" }}>Save</Button>
        </>
      ) : (
        <>
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              fontSize: 18,
              mb: 2,
              mr: 2,
              fontFamily:"Jost"
            }}
          >
            {footers.text}
          </Typography>
          <IconButton
            size="small"
            onClick={() => setFooterEditMode({ ...footerEditMode, text: true })}
            sx={{ bgcolor: "#fff", boxShadow: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </>
      )}
    </Box>
          </Grid>
          {/* Right Column */}
          <Grid item xs={12} md={3} sx={{ml: isMobile ? 8 : 130, mt: isMobile ? 0 :-5 }}>
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              {/* WhatsApp */}
              <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
              {/* Instagram */}
              <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
              {/* Gmail */}
              <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
              {/* YouTube */}
              <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                </Box>
              </a>
            </Box>
          </Grid>
          {/* Bottom Row */}
          <Grid item xs={12} sx={{ borderTop: "1px solid #fff2", mt: 2, pt: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between", alignItems: "center",ml: isMobile ? 2 : 40,}}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {footerEditMode.copyright ? (
                <>
                  <TextField
                    value={footers.copyright}
                    onChange={e => setFooters({ ...footers, copyright: e.target.value })}
                    sx={{ width: 180, mr: 1 }}
                  />
                  <Button variant="contained" onClick={handleSaveFooters} sx={{ height: 40,fontFamily:"Josefin Sans" }}>Save</Button>
                </>
              ) : (
                <>
                  <Typography variant="body2" sx={{ fontSize: 16,fontFamily:"Jost" }}>
                    {footers.copyright}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFooterEditMode({ ...footerEditMode, copyright: true })}
                    sx={{ bgcolor: "#fff", boxShadow: 1, ml: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {footerEditMode.made ? (
                <>
                  <TextField
                    value={footers.made}
                    onChange={e => setFooters({ ...footers, made: e.target.value })}
                    sx={{ width: 220, mr: 1 }}
                  />
                  <Button variant="contained" onClick={handleSaveFooters} sx={{ height: 40,fontFamily:"Josefin Sans" }}>Save</Button>
                </>
              ) : (
                <>
                  <Typography variant="body2" sx={{ fontSize: 16,fontFamily:"Jost" }}>
                    {footers.made}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFooterEditMode({ ...footerEditMode, made: true })}
                    sx={{ bgcolor: "#fff", boxShadow: 1, ml: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* Edit Service Dialog */}
      <Dialog open={editIdx !== null} onClose={() => setEditIdx(null)}>
        <DialogTitle>Edit Service</DialogTitle>
        <DialogContent>
          {/* Image preview and file input */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <img
              src={editImg}
              alt="Service"
              style={{
                width: 180,
                height: 120,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
              }}
                // onClick={handleSaveEditService}
            />
            <input
              id="edit-image-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (ev) => setEditImg(ev.target.result);
                  reader.readAsDataURL(file);
                }
              }}
            />
            <Typography variant="caption" sx={{ color: "#1976d2", cursor: "pointer" }} onClick={() => document.getElementById("edit-image-input").click()}>
              Click image to change
            </Typography>
          </Box>
          <TextField
            label="Title"
            fullWidth
            value={editTitle}
            onChange={e => setEditTitle(e.target.value)}
            sx={{ mb: 2, width: isMobile ? 280 : 500 }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={2}
            value={editDesc}
            onChange={e => setEditDesc(e.target.value)}
            sx={{ width: isMobile ? 280 : 500 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditIdx(null)}>Cancel</Button>
          <Button
            variant="contained"
           onClick={handleSaveEditService}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Dialog */}
      <Dialog open={showDeleteIdx !== null} onClose={() => setShowDeleteIdx(null)}>
  <DialogTitle>Are you sure you want to delete?</DialogTitle>
  <DialogActions>
    <Button onClick={() => setShowDeleteIdx(null)}>No</Button>
    <Button
      variant="contained"
      color="error"
       onClick={handleDeleteService}
    >
      Yes, Delete
    </Button>
  </DialogActions>
</Dialog>
      {/* Edit Service Details Dialog */}
      <Dialog open={editDetailsIdx !== null} onClose={() => setEditDetailsIdx(null)}>
        <DialogTitle>Edit Service Details</DialogTitle>
        <DialogContent>
          <TextField
            label="Details"
            fullWidth
            multiline
            minRows={4}
            value={editDetailsText}
            onChange={e => setEditDetailsText(e.target.value)}
            sx={{ width: isMobile ? 280 : 500 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDetailsIdx(null)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSaveEditDetails}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Add Service Card Dialog */}
      <Dialog open={addCardIdx !== null} onClose={() => setAddCardIdx(null)}>
        <DialogTitle>Add New Service Card</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <img
              src={newCardImg}
              alt="Service"
              style={{
                width: 180,
                height: 120,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
              }}
              onClick={() => document.getElementById("add-service-image-input").click()}
            />
            <input
              id="add-service-image-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (ev) => setNewCardImg(ev.target.result);
                  reader.readAsDataURL(file);
                }
              }}
            />
            <Typography variant="caption" sx={{ color: "#1976d2", cursor: "pointer" }} onClick={() => document.getElementById("add-service-image-input").click()}>
              Click image to change
            </Typography>
          </Box>
          <TextField
            label="Title"
            fullWidth
            value={newCardTitle}
            onChange={e => setNewCardTitle(e.target.value)}
            sx={{ mb: 2, width: isMobile ? 280 : 500 }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={2}
            value={newCardDesc}
            onChange={e => setNewCardDesc(e.target.value)}
            sx={{ mb: 2, width: isMobile ? 280 : 500 }}
          />
          <TextField
            label="Details"
            fullWidth
            multiline
            minRows={4}
            value={newCardDetails}
            onChange={e => setNewCardDetails(e.target.value)}
            sx={{ width: isMobile ? 280 : 500 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddCardIdx(null)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveNewCard}>Add</Button>
        </DialogActions>
      </Dialog>
      {/* Edit Studio Images Dialog */}
      <Dialog open={editStudioImagesOpen} onClose={() => setEditStudioImagesOpen(false)}>
  <DialogTitle>Edit Studio Images (Click an image to change)</DialogTitle>
  <DialogContent>
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2 }}>
      {selectedStudioImages.map((img, idx) => (
        <Box key={idx} sx={{ position: "relative" }}>
          <img
            src={img}
            alt={`preview-${idx}`}
            style={{
              width: 100,
              height: 70,
              objectFit: "cover",
              borderRadius: 6,
              boxShadow: "0 2px 8px rgba(25,118,210,0.10)",
              cursor: "pointer",
              border: editImgIdx === idx ? "2px solid #1976d2" : "2px solid transparent"
            }}
            onClick={() => setEditImgIdx(idx)}
          />
          {/* Hidden file input for each image */}
          {editImgIdx === idx && (
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              id={`studio-img-input-${idx}`}
              onChange={handleSingleStudioImageChange}
            />
          )}
          {editImgIdx === idx && (
            <Button
              variant="outlined"
              size="small"
              sx={{
                position: "absolute",
                top: 5,
                left: 5,
                zIndex: 2,
                bgcolor: "#fff"
              }}
              onClick={() => document.getElementById(`studio-img-input-${idx}`).click()}
            >
              Change
            </Button>
          )}
        </Box>
      ))}
    </Box>
    <Typography variant="caption" sx={{ mt: 2, display: "block", color: "#1976d2" }}>
      Click an image to change it. Only the clicked image will be replaced.
    </Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setEditStudioImagesOpen(false)}>Cancel</Button>
    <Button variant="contained" onClick={handleSaveStudioImages}>Save</Button>
  </DialogActions>
</Dialog>
    </>
  );
};

export default AdminHome;